import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Logout from '../../../shared/Logout/Logout';
import Header from '../../../shared/Header/Header';
import iidIcon from '../Icons/phone.svg';
import tempIcon from '../Icons/tempIcon.svg';
import './ChooseModality.scss';
import imprivataIcon from '../Icons/imprivata.svg';


class ChooseModality extends Component {
  static propTypes = {
    /** Escape */
    backButton: PropTypes.func,
    /** The header text for this screen */
    headerTitle: PropTypes.string,
    /** The description for the header */
    headerDescription: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** What modalities can be chosen -- a modality contains an 'id', 'icon', 'title', 'description', and 'onClickFunction' */
    modalities: PropTypes.array,
    /** Boolean flag dictating whether or not to show the default modality section of the page */
    showDefaultModality: PropTypes.bool,
    /** The name of the default modality displayed at the bottom of the component */
    defaultModality: PropTypes.string,
    /** The the string to be used as the DOM element ID for the default modality component */
    defaultModalityId: PropTypes.string,
    /** The description for the default modality*/
    defaultModalityDescription: PropTypes.object,
    /** The link that clicking the modality goes to  */
    defaultModalityAction: PropTypes.func,
    /** The icon for the last modality */
    defaultModalityIcon: PropTypes.string,
    /** Decide whether to show modality descriptions */
    showDescriptions: PropTypes.bool,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  static defaultProps = {
    headerTitle: 'Verify your identity',
    headerDescription: 'Select a backup login method to verify your identity before adding a new device',
    logoutComponent: <Logout />,
    showDefaultModality: true,
    defaultModality: 'Imprivata ID',
    defaultModalityId: 'btnIid',
    defaultModalityDescription: <span>Use the Imprivata ID app on your smartphone</span>,
    defaultModalityAction: () => window.location = '#',
    defaultModalityIcon: iidIcon,
    defaultModalityIconClass: 'iid-phone-icon',
    modalities: [
      {
        id: '',
        icon: tempIcon,
        title: 'Temporary Code',
        description: <span>Call your help desk for a one time code</span>,
        onClickFunction: () => window.location = '#',
      },
    ],
    // Parkland custom UX
    useCustomUX: false,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldShowDescription = (modality) => {
    return this.props.showDescriptions === true
      || modality.id === 'iid'
      || modality.id === 'btnFace'
      || modality.id === 'btnEmail'
      || modality.id === 'btnTempcode'
      || modality.id === 'btnHelp'
      || modality.id === 'btnPassword'
      || modality.id === 'btnPin'
      || modality.id === 'btnIdv'
      || modality.id === 'btnProxCard';
  };

  render() {
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        {this.props.useCustomUX ?
          (<Header />)
          :
          (
            <div className='Header-Box'>
              <div className='Header-Text'>
                <span>{this.props.headerTitle}</span>
              </div>
              <div className='Header-Description'>
                <span>{this.props.headerDescription}</span>
              </div>
            </div>
          )
        }
        <div className='Modality-List'>
          {this.props.modalities.map(modality =>
            <div className='Modality-Block' key={modality.id}>
              <div className='Modality-Circle'>
                <img src={modality.icon}
                  alt='icon'
                  title={modality.title}
                  onClick={modality.onClickFunction}
                  id={modality.id}
                  key={modality.title}
                />
              </div>
              {modality.onClickFunction &&
                <p>
                  {(modality.description !== '' && modality.description != null && modality.description.length > 0) ?
                    <span onClick={modality.onClickFunction} className='Modality-Text clickable'>{modality.title}</span>
                    :
                    <span onClick={modality.onClickFunction} className='Modality-Text-Centered clickable'>{modality.title}</span>
                  }
                  <br />
                  <span className='Small-Font Modality-Text'>
                    {this.shouldShowDescription(modality)
                      ? modality.description
                      : null}
                  </span>
                </p>
              } {!(modality.onClickFunction) &&
                <p>
                  <span className='Modality-Text'>{modality.title}</span>
                  <br />
                  <span className='Small-Font Modality-Text'>
                    {this.shouldShowDescription(modality)
                      ? modality.description
                      : null}
                  </span>
                </p>
              }
            </div>
          )}
          {this.props.showDefaultModality &&
            <div>
              <div className='choose-modality-row-divider'>
                <strong className='Modality-Text'>Still have your original device?</strong>
              </div>
              <div className='Default-Modality-Block'>
                <div className='Modality-Circle'>
                  <img src={this.props.defaultModalityIcon}
                    alt='icon'
                    title={this.props.defaultModality}
                    onClick={this.props.defaultModalityAction}
                    id={this.props.defaultModalityId}
                    key={this.props.defaultModality}
                  />
                </div>
                {this.props.defaultModalityAction &&
                  <p>
                    <span onClick={this.props.defaultModalityAction} className='Modality-Text clickable'>{this.props.defaultModality}</span>
                    <br />
                    <span className='Small-Font Modality-Text'>{this.props.defaultModalityDescription}</span>
                  </p>
                } {!(this.props.defaultModalityAction) &&
                  <p>
                    <span className='Modality-Text'>{this.props.defaultModality}</span>
                    <br />
                    <span className='Small-Font Modality-Text'>{this.props.defaultModalityDescription}</span>
                  </p>
                }
              </div>
            </div>}
        </div>
        <hr className='Footer-hr' />
        <img className='Footer' src={imprivataIcon} alt='logo' />
      </div>
    );
  }
}

export default ChooseModality;
